import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=2471027a&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=2471027a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471027a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/xinyu/.jenkins/workspace/vue-Commonality-CMS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2471027a')) {
      api.createRecord('2471027a', component.options)
    } else {
      api.reload('2471027a', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=2471027a&scoped=true&", function () {
      api.rerender('2471027a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "oxygen/cms/components/common/Toast/Main.vue"
export default component.exports